import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
import UserChatMessage from '../chat/UserChatMessage';
const Container = styled.div`
  height: ${(props)=>props.height}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;
const MessageList = ({ messages, currentUserId, height, onLoadMore, hasMore, isLoading, onMessageClick, autoScrollToBottom })=>{
    const containerRef = React.useRef(null);
    React.useEffect(()=>{
        if (autoScrollToBottom && containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    }, [
        messages,
        autoScrollToBottom
    ]);
    return /*#__PURE__*/ _jsxs(Container, {
        ref: containerRef,
        height: height,
        "data-testid": "people-chat-message-list",
        children: [
            hasMore && /*#__PURE__*/ _jsx("div", {
                style: {
                    textAlign: 'center',
                    padding: '1rem'
                },
                children: isLoading ? 'Loading...' : /*#__PURE__*/ _jsx("button", {
                    onClick: onLoadMore,
                    children: "Load More"
                })
            }),
            messages.map((message, index)=>/*#__PURE__*/ _jsx("div", {
                    onClick: ()=>onMessageClick?.(message),
                    children: /*#__PURE__*/ _jsx(UserChatMessage, {
                        message: message,
                        isOwn: message.senderId === currentUserId
                    })
                }, message.id || index))
        ]
    });
};
export default MessageList;
